import {
    IParsedStackedSymbolName,
    ISymbolStateConfig,
    StateReelSymbol
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpacierArcadeParsedInitData} from "../server/data/SpacierArcadeParsedInitData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SASymbols, SpacierArcadeReelSymbol} from "../symbols/SpacierArcadeReelSymbol";
import {SAReelView} from "./SAReelView";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";

export class SAReelEvent{
    static readonly SHOW_FREE_SPIN_REEL_VIEW: string = "saReelEvent_showFreeSpinReelView";
    static readonly SHOW_BASE_GAME_REEL_VIEW: string = "saReelEvent_showBaseSpinReelView";
    static readonly UPDATE_NEAR_REEL_VIEW: string = "saReelEvent_updateNearReelView";
    static readonly RESET_NEAR_REEL_VIEW: string = "saReelEvent_resetNearReelView";

}

export class SAReelController extends SpinReelController{
    private _isRestore:boolean;
    private _fsWildPos:number[][];
    private _overlaySymbolsBeforeSpin: string[][];
    private _overlaySymsLength: any = {
        "NORMAL": 3,
        "WILD_RESPIN" : 3,
        "FREESPIN": 5,
        "FREESPIN_WIN_RESPIN": 5
    }
    constructor(reelId:number) {
        super(reelId);
    }

    private inMainGame(mode:string):boolean{
        return (mode === SpacierArcadeGameMode.NORMAL || mode === SpacierArcadeGameMode.RESPIN);
    }

    protected checkIsFreespin():boolean {
        return (this._gameMode === SpacierArcadeGameMode.FREESPIN || this._gameMode === SpacierArcadeGameMode.FREESPIN_RESPIN );
    }

    protected onInitDataParsed(data:SpacierArcadeParsedInitData):void {
        this._isRestore = data.isRestoreState;
        if(data.isRestoreState && data.nextMode === SpacierArcadeGameMode.FREESPIN_RESPIN || data.nextMode === SpacierArcadeGameMode.FREESPIN){
            SpacierArcadeGameConfig.instance.reelViewExpanded = true;
            EventHandler.dispatchEvent(new GameEvent(SAReelEvent.SHOW_FREE_SPIN_REEL_VIEW));
        }
        this._fsWildPos = data.fsWildPositions;
        super.onInitDataParsed(data);
    }

    public updateGameData(data:SpacierArcadeParsedGameData):void{
        this._isRestore = false;
        this._gameMode = data.mode;
        this._nextGameMode = data.nextMode;
        this._stopReelSet = data.reels[this._reelId];
        this._fsWildPos = data.fsWildPositions;
        this._overlaySymbolsBeforeSpin = data.overlaySymbolsBeforeSpin;
    }

    protected initReelStrip(setAlpha:number = 0, enteringFreespin:boolean = false):void{
        super.initReelStrip();
        if(this.allSymbols && this.allSymbols.length > 0) {
            const symbolAbove = this.findSymbol(enteringFreespin? -1 : (this.checkIsFreespin() || this._isRestore)? -1: 1);
            const symbolBelow = this.findSymbol(5);
            if (symbolAbove && symbolBelow) {
                symbolAbove.alpha = setAlpha;
                symbolBelow.alpha = setAlpha;
            }

        }
    }

    protected initAnimator(height:number = SpacierArcadeGameConfig.instance.SYMBOL_HEIGHT):void {
        this._reelPartAnimator.symWidth = SpacierArcadeGameConfig.instance.SYMBOL_WIDTH;
        this._reelPartAnimator.symHeight = (this.checkIsFreespin() && this._isRestore) ? SpacierArcadeGameConfig.instance.SYMBOL_HEIGHT_FREESPIN :  height;
        this._reelPartAnimator.symBottomPadding = SpacierArcadeGameConfig.instance.SYMBOL_BOTTOM_PADDING;
    }

    // The stop offset is for features on the reel to prolong the stop.
    // The reelArea will take the biggest offset as the real stop offset.
    public getSpinStopOffset():number {
        if(this._currentState === ReelAnimationState.INACTIVE || this._currentState === ReelAnimationState.IDLE) {
            return 0;
        }


        if(this._stopReelSet.length === 0) {
            return 0;
        }
        // check if there is unfinished stacked wilds in the bottom of the stop reel set.
        // When the offset is more than 0, we have to make sure to compensate it from the stop reel set.
        let spinStopOffset:number = 0;
        let bottomSymbol:string = this._stopReelSet[this._stopReelSet.length - 1];
        let parsedStackedName:IParsedStackedSymbolName = StateReelSymbol.parseStackedSymbolName(bottomSymbol, this._reelId);
        if(parsedStackedName.isStacked && parsedStackedName.index < (parsedStackedName.totalNum - 1)) {
            spinStopOffset = parsedStackedName.totalNum - 1 - parsedStackedName.index;
        }

        return Math.max(0, spinStopOffset - GameConfig.instance.SYMBOLS_NUM_IN_REEL[4]);
    }


    protected addNewSymbol(symName:string, state?:ISymbolStateConfig, skipWild?:boolean):StateReelSymbol {
        if(state == null) {
            state = this._isSpinBlurred ? GameConfig.instance.SYMBOL_STATES.spin : GameConfig.instance.SYMBOL_STATES.normal;
        }

        if(this._fsWildPos !== undefined && this._fsWildPos.length > 0 && !skipWild){
            for(let i:number = 0; i < this._fsWildPos.length; i++) {
                if (this.reelId === this._fsWildPos[i][0] && symName === SASymbols.W) {
                    symName = SASymbols.L2;
                }
            }
        }

        // const symbol:SpacierArcadeReelSymbol = <SpacierArcadeReelSymbol>this._reelPartCreator.createNewSymbol(symName, this._reelId, state);
        const symbol:SpacierArcadeReelSymbol = <SpacierArcadeReelSymbol>this._reelPartCreator.createNewSymbol(symName, this._reelId, state, {
                        width : this._reelPartAnimator.symWidth,
                       height : this._reelPartAnimator.symHeight,
                        bottomPadding : this._reelPartAnimator.symBottomPadding
                });

        symbol.x = 0;
        symbol.y = -symbol.symHeight / 2 - GameConfig.instance.REEL_AREA_POS_Y - (this.checkIsFreespin()? 0 : GameConfig.instance.REEL_DISPLAY_POSITIONS[this._reelId][1]); // this is just a temp position that's not visible. this position might be visible in portrait mode but it doesn't matter. the position will be updated when put the symbol to the animator.
        this._reelView.addChild(symbol);
        symbol.controller = this;
        return symbol;
    }

    public resetReelSymbols(symHeight:number, reelSymbols:string[], enteringFreespin:boolean = false, setAlpha:number = 0):void {
        this.initAnimator(symHeight);

        // remove all current symbols.
        while(this.allSymbols.length > 0) {
            this.removeReplacedSymbol(this.allSymbols.pop()!);
        }
        // create new symbols
        this._stopReelSet = reelSymbols.concat();
        this.initReelStrip(setAlpha, enteringFreespin);
    }



    public removeReplacedSymbol(replacedSymbol:StateReelSymbol):void {
        this._reelView.removeChild(replacedSymbol);
        this._reelPartCreator.deleteSymbol(replacedSymbol);
    }

    public replaceWithNewSymbol(oldSymbol:StateReelSymbol, symName:string, deleteOld:boolean, state?:ISymbolStateConfig):any {
        //Creates and adds it to the view
        const newSymbol = this.addNewSymbol(symName, state, true);
        newSymbol.x = oldSymbol.x;
        newSymbol.y = oldSymbol.y;

        const reelPartIndex = this._reelPartAnimator.symbolsToAnimate.indexOf(oldSymbol);
        this._reelPartAnimator.symbolsToAnimate[reelPartIndex] = newSymbol;

        const stopSymbolIndex = this.allSymbols.indexOf(oldSymbol);
        this.allSymbols[stopSymbolIndex] = newSymbol;

        if(deleteOld) {
            this.removeTheOldSymbol(oldSymbol);
        }
        return newSymbol;
    }

    public removeTheOldSymbol(oldSymbol:StateReelSymbol) {
        this._reelPartCreator.deleteSymbol(oldSymbol);
    }

    public moveSymbolToBottomLayer(symbol:SpacierArcadeReelSymbol) {
        (<SAReelView>this._reelView).bottomLayer.addChild(symbol);
    }


    public moveSymbolToSpecialLayer(symbol:StateReelSymbol) {
        (<SAReelView>this._reelView).attentionLayer.addChild(symbol);
    }



    //Stop delays

    protected getQuickStopDelay(reelId:number):number {
        return this.getFeatureSpecificStopDelays(reelId, () => super.getQuickStopDelay(reelId));
    }

    protected getFastSpinStopDelay(reelId:number):number {
        return this.getFeatureSpecificStopDelays(reelId, () => super.getFastSpinStopDelay(reelId));
    }

    protected getNormalStopDelay(reelId:number):number {
        return this.getFeatureSpecificStopDelays(reelId, () => super.getNormalStopDelay(reelId));
    }

    private getFeatureSpecificStopDelays(reelId:number, superFunction:Function):number {
        if((this._nextGameMode !== SpacierArcadeGameMode.NORMAL && (this._gameMode === SpacierArcadeGameMode.RESPIN || this._nextGameMode === SpacierArcadeGameMode.RESPIN))
            || (this._nextGameMode !== SpacierArcadeGameMode.FREESPIN &&(this._gameMode === SpacierArcadeGameMode.FREESPIN_RESPIN || this._nextGameMode === SpacierArcadeGameMode.FREESPIN_RESPIN))){
            const overlaySyms:string[] = this._overlaySymbolsBeforeSpin[this.reelId];
            if(overlaySyms.filter( (item) => { return item !== null }).length >= this._overlaySymsLength[this._nextGameMode]){
                return 0;
            }
        }
        return superFunction();
    }
}